export default "/public/app-main/static/image/28c17ba015c665888ae6dd8f960434f6.png";